import { render, staticRenderFns } from "./LandownerReportForm.vue?vue&type=template&id=146ff670"
import script from "./LandownerReportForm.vue?vue&type=script&lang=js"
export * from "./LandownerReportForm.vue?vue&type=script&lang=js"
import style0 from "./LandownerReportForm.vue?vue&type=style&index=0&id=146ff670&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports